import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffBankAccountRequest,
  StaffBankAccountResponse,
} from "../model/bank-account.model";

@Injectable({ providedIn: "root" })
export class StaffBankAccountsService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/bank-accounts`;
  }

  list(filters?: {
    companyId?: number;
    status?: string;
    paymentTypeCode?: string;
    currencyCode?: string;
  }): Observable<StaffBankAccountResponse[]> {
    let params = new HttpParams();
    if (filters?.companyId != null)
      params = params.set("companyId", filters.companyId);
    if (filters?.status) params = params.set("status", filters.status);
    if (filters?.paymentTypeCode)
      params = params.set("paymentTypeCode", filters.paymentTypeCode);
    if (filters?.currencyCode)
      params = params.set("currencyCode", filters.currencyCode);
    return this.http.get<StaffBankAccountResponse[]>(this.url, { params });
  }

  getById(id: number): Observable<StaffBankAccountResponse> {
    return this.http.get<StaffBankAccountResponse>(`${this.url}/${id}`);
  }

  create(
    request: StaffBankAccountRequest,
  ): Observable<StaffBankAccountResponse> {
    return this.http.post<StaffBankAccountResponse>(this.url, request);
  }

  update(
    id: number,
    request: StaffBankAccountRequest,
  ): Observable<StaffBankAccountResponse> {
    return this.http.put<StaffBankAccountResponse>(
      `${this.url}/${id}`,
      request,
    );
  }

  setStatus(id: number, active: boolean): Observable<StaffBankAccountResponse> {
    return this.http.patch<StaffBankAccountResponse>(
      `${this.url}/${id}/status`,
      { active },
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
